"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputSchema = exports.textInputSchema = void 0;
exports.default = TextInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.textInputSchema = zod_1.z.string();
const ssn = zod_1.z.coerce.string().regex(/^\d{3}-\d{2}-\d{4}$|^\d{9}$/, 'Valid Social Security Number Required');
exports.TextInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    // validations:
    default: zod_1.z.string().min(1, 'Required'),
    notRequired: zod_1.z.string(),
    email: zod_1.z.string().email(),
    ssn,
    ssnNotRequired: ssn.or(zod_1.z.literal('')),
    zip: zod_1.z.coerce.string().regex(/^\d{5}$|^\d{5}-\d{4}$/, 'Valid Zip Code Required'),
});
function TextInput(_a) {
    var { label, name, required = true, maxLength, placeholder, disabled = false, dataTestId, enforceAlphaNumeric = true, autoComplete = 'off', multiline = false, rows, inputProps } = _a, props = __rest(_a, ["label", "name", "required", "maxLength", "placeholder", "disabled", "dataTestId", "enforceAlphaNumeric", "autoComplete", "multiline", "rows", "inputProps"]);
    const { control } = (0, react_hook_form_1.useFormContext)();
    const fieldId = (0, react_1.useId)();
    const testId = dataTestId ? `${dataTestId}_${fieldId}` : 'form_field_text_input';
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = (0, react_hook_form_1.get)(errors, name);
    const handleChange = (e) => {
        const value = e.currentTarget.value;
        if (!enforceAlphaNumeric)
            field.onChange(e.target.value);
        if (value.match(/^[a-zA-Z0-9\-/ ]*$/)) {
            field.onChange(e.target.value);
        }
    };
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, Object.assign({}, field, { fullWidth: true, label: label, disabled: disabled, error: Boolean(error), helperText: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: error === null || error === void 0 ? void 0 : error.message }), required: required, placeholder: placeholder, onChange: (e) => handleChange(e), autoComplete: autoComplete, inputProps: Object.assign({ maxLength, 'data-test-id': testId }, inputProps), multiline: multiline, rows: rows }, props)));
}
//# sourceMappingURL=TextInput.js.map